import type { TaskStatus, TeamTaskDto } from "@/modules/boxDashboard/gateway/boxDashboardApiDto"
import { BoxStaffItemEntity } from "@modules/boxStaff/entities/boxStaffEntity"
import dayjs from "dayjs"
import relativeTime from "dayjs/plugin/relativeTime"

dayjs.extend(relativeTime)

export class TeamTaskEntity {
  constructor(
    public readonly id: string,
    public readonly task: string,
    public readonly taskStatus: TaskStatus,
    public readonly creator: BoxStaffItemEntity,
    public readonly completedBy: BoxStaffItemEntity | null,
    public readonly createdDate: string,
    public readonly completedDate: string | null,
    public readonly archivedDate: string | null,
    public readonly archived: boolean,
  ) {}

  static fromDto(dto: TeamTaskDto): TeamTaskEntity {
    return new TeamTaskEntity(
      dto.id,
      dto.task,
      dto.taskStatus,
      BoxStaffItemEntity.fromItemDto(dto.creator),
      dto.updater ? BoxStaffItemEntity.fromItemDto(dto.updater) : null,
      dto.createdDate,
      dto.completedDate,
      dto.archivedDate,
      dto.archived,
    )
  }

  isCompleted(): boolean {
    return this.taskStatus === "COMPLETED"
  }

  isCreated(): boolean {
    return this.taskStatus === "CREATED"
  }

  isDeleted(): boolean {
    return this.taskStatus === "DELETED"
  }

  isArchived(): boolean {
    return this.archived
  }

  getCreatedDateFormatted(): string {
    return dayjs(this.createdDate).format("l")
  }

  getCompletedDateFormatted(): string | null {
    if (!this.completedDate) return null
    return dayjs(this.completedDate).format("l")
  }

  getCreatedDateRelative(): string {
    return dayjs(this.createdDate).fromNow()
  }

  getCreatorName(): string {
    return this.creator.getFullName()
  }

  getCompletedByName(): string | null {
    return this.completedBy?.getFullName() ?? null
  }
}
